import Requester from '../components/Requester';
import urlConfig from '../config/urlConfig';
import constants from '../utils/constants';
import helpers from '../utils/helpers';

export default {
  getAllNotification: () => Requester(helpers.createRequesterOptions(urlConfig.notification.getAllNotification, constants.requestType.get)),
  readAllNotification: () => Requester(helpers.createRequesterOptions(urlConfig.notification.readAllNotification, constants.requestType.get)),
  getNotifications: (model) => Requester(helpers.createRequesterOptions(urlConfig.notification.getNotifications, constants.requestType.post, model)),
  getUnReadNotificationCount: () => Requester(helpers.createRequesterOptions(urlConfig.notification.getUnReadNotificationCount, constants.requestType.get,)),
  readNotification: (model) => Requester(helpers.createRequesterOptions(urlConfig.notification.readNotification, constants.requestType.post, model)),
};
